import { SharePointListClient, odataEscape, type ListItem } from '../SharePointListClient';

/**
 * `17.AutorizacionDescuentos` — pending approval requests emitted when a
 * Nueva Cotización line exceeds the vendor's monthly allowance for its
 * discount bracket. The approval UI itself lives in the future
 * Aprobaciones module — this stage only creates the rows with
 * `Status_AD = 'Pendiente'`.
 */
export type AutorizacionDescuentosFields = {
  Title?: string | null;
  IDOperacion_AD?: string | null;
  IDDetalle_AD?: string | null;
  IDArticulo_AD?: string | null;
  Articulo_AD?: string | null;
  Descuento_AD?: string | null;
  Motivo_AD?: string | null;
  Status_AD?: 'Pendiente' | 'Aprobado' | 'Rechazado' | string | null;
  /** Vendor (UsuarioApp) who triggered the request. Live backfill maps this to `solicitante_id`. */
  Usuario_AD?: string | null;
  Fecha_AD?: string | null;
  Mes_AD?: string | null;
  MesAnio_AD?: string | null;
  Anio_AD?: string | null;
  Hora_AD?: string | null;
  /** MX Nova snapshot — true when applying this discount would put
   *  the venta below the cost+commission+IVA threshold. Drives the
   *  "Horno usado" badge in the Aprobaciones table + approve dialog. */
  WasUsado_AD?: boolean | null;
};

export type AutorizacionDescuentosItem = ListItem<AutorizacionDescuentosFields>;

export const autorizacionDescuentosClient = new SharePointListClient<AutorizacionDescuentosFields>(
  'AutorizacionDescuentos',
);

/**
 * List every authorization row tied to a given cotización that is still
 * waiting on an approver. Detalle Venta uses this both to drive the
 * "aprobaciones pendientes" alert on the screen and to soft-cancel these
 * rows when the user Anula the cotización.
 */
export async function listPendingByOperacion(
  operacionId: string | number,
): Promise<AutorizacionDescuentosItem[]> {
  return autorizacionDescuentosClient.listItems({
    filter: `fields/IDOperacion_AD eq ${odataEscape(String(operacionId))} and fields/Status_AD eq 'Pendiente'`,
  });
}

/**
 * Global pending queue for the Aprobaciones screen. Both `IDOperacion_AD`
 * and `Status_AD` are indexed, so this is safe to run without a top bound;
 * the page caches the result in React Query.
 */
export async function listAllPendingDescuentos(): Promise<AutorizacionDescuentosItem[]> {
  return autorizacionDescuentosClient.listItems({
    filter: `fields/Status_AD eq 'Pendiente'`,
    orderBy: 'fields/Created desc',
  });
}
